import { of } from "rxjs";
import { combineEpics } from "redux-observable";
import { searchBudgetActionTypes, loadingBudgetRequest, loadedBudgetRequest, loadExperimentBudgetActionTypes, loadingExperimentBudget, loadedExperimentBudget } from "./SearchContainer.ducks.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import BudgetResource from "../../resources/budget.resource.js";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
const searchBudgetArgs = {
  filterOnType: searchBudgetActionTypes.LOAD,
  loadResource: (request) => BudgetResource.searchBudget(request),
  loadingAction: loadingBudgetRequest,
  loadedAction: (successData, payload, error) => {
    return of(loadedBudgetRequest(getCompletedAsyncWrapperObj(successData, error)));
  }
};
const searchBudgetEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(searchBudgetArgs);
const getExperimentBudgetArgs = {
  filterOnType: loadExperimentBudgetActionTypes.LOAD,
  loadResource: (payload) => BudgetResource.getBudgetForExperiment(payload.experimentId),
  loadingAction: loadingExperimentBudget,
  loadedAction: (successData, payload, error) => {
    return of(loadedExperimentBudget(getCompletedAsyncWrapperObj(successData, error)));
  }
};
const getExperimentBudgetEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getExperimentBudgetArgs);
const SearchContainerEpics = combineEpics(searchBudgetEpic, getExperimentBudgetEpic);
export {
  SearchContainerEpics as default,
  getExperimentBudgetEpic,
  searchBudgetEpic
};
//# sourceMappingURL=SearchContainer.epics.js.map
